import { IEdgeData } from "components/CurrentNewTree/type"

export const getSiblingsEdgeData = ({ sourceId, targetId, pos }: IEdgeData) => (
    {
        type: 'smoothstep',
        sourceHandle: 'SourceTop',
        targetHandle: 'TarTop',
        source: sourceId,
        target: targetId,
    }
)